<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";
	import translations from "./Labelled.translations.json" with { type: "json" };

	const {
		horizontal,
		label,
		required,
		content,
		wrapperClass,
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
	} = $props();

	const translate = getTranslate(translations);
</script>

<div class={["flex text-left gap-1.5 md:gap-3", horizontal ? "flex-row items-center" : "flex-col", wrapperClass]}>
	{#if horizontal}
		{@render content()}
	{/if}
	<label {...label}>
		{@render rest.children?.()}
		{#if required}
			<span class="self-start" title={translate("required")}>*</span>
		{/if}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
</div>
